import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Clone / git checkout icon.
 *
 * A git branch symbol: two circles connected by a curved line,
 * with one circle having a vertical line going up. Represents
 * code cloning / branch checkout.
 *
 * Dual-tone layered:
 * - Outlines: currentColor, 2px stroke, round caps/joins
 * - One circle: cyan accent fill at 10%
 */
export const CloneIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Vertical line going up from the left circle */}
    <path
      d="M7 14 L7 6"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Curved connector between the two circles */}
    <path
      d="M7 14 C7 18 17 18 17 14"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Left circle (with cyan accent fill) */}
    <circle
      cx={7}
      cy={14}
      r={2}
      fill="#00d4ff"
      fillOpacity={0.1}
      stroke="currentColor"
      strokeWidth={2}
    />
    {/* Right circle (outline only) */}
    <circle
      cx={17}
      cy={14}
      r={2}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
    />
  </RushaSvgIcon>
);

CloneIcon.displayName = "CloneIcon";

export default CloneIcon;
